/*
 * Created by: bpietroiu
 * Date: 7/16/13  10:33 AM
 */

/**
 * @class TS.domain.properties.AdaptiveLookupProperty
 * @extends TS.domain.properties.SelectionListProperty
 * @classdesc Similar to {@link TS.domain.properties.SelectionListProperty SelectionListProperty}, but has the ability to push multiple values
 * into the model when the user selects an item.
 */
TS.domain.properties.AdaptiveLookupProperty = new Class(
/** @lends TS.domain.properties.AdaptiveLookupProperty# */
{
    Extends: TS.domain.properties.SelectionListProperty,

    initialize: function (domain, config) {
        var me = this;
        me.parent(domain, config);
        Object.defineProperty(me, 'Model', {
            get: function () {
                return me.ListSource;
            }
        });
    },

});

TS.ObjectFactory.map('AdaptiveLookupProperty', TS.domain.properties.AdaptiveLookupProperty);
